import React from 'react'
import { IDropOffProvider } from '../../domain/providers/DropOffProvider'
import { IDropOffTypeProvider } from '../../domain/providers/DropOffTypeProvider'
import { IGeocodingProvider } from '../../domain/providers/IGeocodingProvider'
import { IGeolocationProvider } from '../../domain/providers/IGeolocationProvider'
import { INewDropoffProvider } from '../../domain/providers/INewDropoffProvider'
import { IRewardProvider } from '../../domain/providers/IRewardProvider'
import { IMultisearchProvider } from '../../domain/providers/MultisearchProvider'
import { ITenantProvider } from '../../domain/providers/TenantProvider'
import { IWasteTypeProvider } from '../../domain/providers/WasteTypeProvider'

export interface IAppProviderContext {
  dropOffProvider?: IDropOffProvider
  tenantProvider?: ITenantProvider
  dropOffTypeProvider?: IDropOffTypeProvider
  wasteTypeProvider?: IWasteTypeProvider
  geolocationProvider?: IGeolocationProvider
  geocodingProvider?: IGeocodingProvider
  newDropoffProvider?: INewDropoffProvider
  multisearchProvider?: IMultisearchProvider
  rewardProvider?: IRewardProvider
}

export const AppProviderContext = React.createContext<IAppProviderContext>({})

export const useAppProviderContext = (): IAppProviderContext => React.useContext(AppProviderContext)
